import { baseApi } from 'lib/rtkQuery/baseApi';
import { QueryTags } from 'lib/rtkQuery/constants';
import { QueryResponse } from 'lib/rtkQuery/types';
import {
  TDeletePeakPayload,
  TGetPeakParams,
  TGetPeaksParams,
  TPeakSeasonConfig,
} from './types';

const endpoint = '/ocs';

export const peakApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [QueryTags.PeaksConfig],
  })
  .injectEndpoints({
    endpoints: builder => ({
      GetPeaks: builder.query<
        QueryResponse<TPeakSeasonConfig[]>,
        TGetPeaksParams
      >({
        query: (params: TGetPeaksParams) => ({
          url: `${endpoint}/peak/get-list`,
          method: 'GET',
          params,
        }),
        providesTags: [QueryTags.PeaksConfig],
      }),

      GetAllPeak: builder.query<QueryResponse<TPeakSeasonConfig[]>, void>({
        query: () => ({
          url: `${endpoint}/peak/get-all`,
          method: 'GET',
        }),
        providesTags: [QueryTags.PeaksConfig],
      }),

      GetPeak: builder.query<QueryResponse<TPeakSeasonConfig>, TGetPeakParams>({
        query: (params: TGetPeakParams) => ({
          url: `${endpoint}/peak/get`,
          method: 'GET',
          params,
        }),
      }),

      UpdatePeak: builder.mutation<QueryResponse<string>, TPeakSeasonConfig[]>({
        query: payload => ({
          url: `${endpoint}/upsert/peak`,
          method: 'POST',
          data: payload,
        }),
        invalidatesTags: (_, error) => (!!error ? [] : [QueryTags.PeaksConfig]),
      }),

      DeletePeak: builder.mutation<QueryResponse<string>, TDeletePeakPayload>({
        query: payload => ({
          url: `${endpoint}/peak/delete`,
          method: 'DELETE',
          data: payload,
        }),
      }),
    }),
  });

export const {
  useUpdatePeakMutation,
  useGetPeaksQuery,
  useGetPeakQuery,
  useDeletePeakMutation,
  useGetAllPeakQuery,
} = peakApi;
